import axios from 'axios'
import router from '@/router'
import { __setlocalStorage, _PHONE, __clearlocalStorage } from '@/utils/utils'
import store from '../store/index'
import { Toast } from 'vant'

// import elementPublic from '@/utils/elementPublic'

/**
 * 封装ajax请求
 * 1.reqUrl、reqMethod为必填选项
 * 2.type存在时导出数据
 * @param {String}   reqMethod                请求方式
 * @param {JSON}     reqData                  请求数据
 * @param {Function} callback                 回调函数
 * @param {Function} dir                      直接返回响应数据
 */
// json 数据格式
export function myAjax(reqMethod, reqData, callback, dir, toastVisible = true) {
  const header = {
    'Content-Type': 'application/x-www-form-urlencoded',
    // 'Content-Type': 'application/json;charset=UTF-8'
  }
  const reqParam = {
    url: process.env.VUE_APP_APIURL,
    headers: header,
    method: reqMethod,
    timeout: 15000,
  }
  const hostname = window.location.hostname
  const domain = hostname === 'localhost' ? 'enweb.xiyijst.com' : hostname
  reqData.version = window.version
  reqData.domain = domain
  if (reqMethod == 'get') {
    reqParam.params = reqData
  } else {
    reqParam.data = reqData
    if (reqParam.data.act != 'login') {
      reqParam.data.passport = store.state.passport || ''
    }
  }

  axios({
    ...reqParam,
  })
    .then((data) => {
      if (dir) {
        callback(data.data)
      } else if (data.data.ret == 'succ') {
        if (data.data.clientAct == 'countryareas') {
          //新省市县地址数据整合
          let newarr = []
          newarr = data.data.data.split(';').map((item) => {
            let obj = {}
            obj.id = item.split(',')[0]
            obj.pid = item.split(',')[1]
            obj.ppid = item.split(',')[2]
            obj.name = item.split(',')[3]
            return obj
          })
          data.data.data = newarr
        }
        callback(data.data)
      } else {
        if (toastVisible) {
          Toast(data.data.tip)
        }
        if (data.data.clientAct != 'webconfig' && (data.data.err == 'logerr' || data.data.eno == 102)) {
          __setlocalStorage('passport', '')
          __setlocalStorage('user', {})
          __setlocalStorage('shopinfo', {})
          __setlocalStorage('topinfo', {})
          __setlocalStorage('encrypted', '')
          var u = navigator.userAgent
          var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端
          var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
          if (isiOS) {
            // _PHONE("XYJS.doRemove", 1, "encrypted");
          }
          // 获取当前的路由路径
          const currentPath = router.currentRoute.path
          if (currentPath !== '/login') {
            // 如果当前路径不是登录页面，则跳转到登录页面
            store.commit('SET_AFTER_LOGIN_PATH', currentPath) // 设置登录后的重定向路径
          }
          router.push({ path: '/login' })
          __clearlocalStorage()
        }
      }
    })
    .catch((err) => {
      console.log("🚀 ~ myAjax ~ err:", err)
      if (!navigator.onLine) {
        Toast('The network connection has been disconnected!')
        console.error('The network connection has been disconnected!')
        // 可以在这里处理没有网络的情况，比如提示用户或者重试等
      }
    })
}
